import type { RolePlayResultFragment } from '@/gql/codegen/graphql';
import type React from 'react';
import { EvaluationMark } from '../../../-components/EvaluationMark';
import { EvaluationPassRate } from '../../../-components/EvaluationPassRate';
import styles from './index.module.scss';

type EvaluationItem =
  RolePlayResultFragment['evaluationItemsWithResults'][number];

export type EvaluationSummaryProps = {
  title: string;
  firstPassRate: number | null | undefined;
  secondPassRate: number | null | undefined;
  isFirst: boolean;
  evaluationItemsWithResults: EvaluationItem[];
};

export const EvaluationSummary: React.FC<EvaluationSummaryProps> = ({
  title,
  firstPassRate,
  secondPassRate,
  isFirst,
  evaluationItemsWithResults,
}) => {
  const isSecond = !isFirst;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.titleArea}>
          <p className={styles.subtitle}>評価項目ごとの達成率</p>
          <h3 className={styles.title}>{title}</h3>
        </div>

        <div
          className={`${styles.scoreHeader} ${isFirst ? styles.scoreHeaderActive : ''}`}
        >
          <div className={styles.scoreLabel}>ファースト</div>
          <EvaluationPassRate score={firstPassRate} isActive={isFirst} />
        </div>

        <div
          className={`${styles.scoreHeader} ${isSecond ? styles.scoreHeaderActive : ''}`}
        >
          <div className={styles.scoreLabel}>セカンド</div>
          <EvaluationPassRate score={secondPassRate} isActive={isSecond} />
        </div>
      </div>

      {evaluationItemsWithResults.map((item) => (
        <div key={item.id} className={styles.item}>
          <div className={styles.itemContent}>
            <h4 className={styles.itemTitle}>{item.title}</h4>
            <p className={styles.itemDescription}>{item.description}</p>
          </div>

          <div
            className={
              isFirst ? styles.evaluationCellActive : styles.evaluationCell
            }
          >
            <EvaluationMark
              isPassed={item.firstResultEvaluationItem.isPassed}
            />
          </div>
          <div
            className={
              isSecond ? styles.evaluationCellActive : styles.evaluationCell
            }
          >
            <EvaluationMark
              isPassed={item.secondResultEvaluationItem?.isPassed}
            />
          </div>
        </div>
      ))}
    </div>
  );
};
